import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf7.png';

const GrossMarginsStep4 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="GROSS MARGINS"
    hideAlert={true}
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        The Marketing and Operation Analysis sections of the Team Report, would be a good
        place to evaluate your product's selling price and unit costs in relation to your competitors.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default GrossMarginsStep4;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/gross-margins/step4.js